var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 0H2.625C1.17523 0 0 1.17523 0 2.625V18.375C0 19.8248 1.17523 21 2.625 21H25.375C26.8248 21 28 19.8248 28 18.375V2.625C28 1.17523 26.8248 0 25.375 0ZM25.375 2.625V4.85652C24.1488 5.85506 22.1939 7.40775 18.0148 10.6802C17.0938 11.4046 15.2694 13.1451 14 13.1248C12.7308 13.1453 10.9058 11.4044 9.98523 10.6802C5.80672 7.40824 3.85137 5.85523 2.625 4.85652V2.625H25.375ZM2.625 18.375V8.22489C3.87811 9.22299 5.65518 10.6236 8.3638 12.7446C9.5591 13.6855 11.6524 15.7626 14 15.7499C16.3361 15.7626 18.4028 13.7156 19.6357 12.745C22.3443 10.6241 24.1218 9.2231 25.375 8.22495V18.375H2.625Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.044efa88826cc5355667ada9240b4470.svg";
export { ForwardRef as ReactComponent };